module.exports = __webpack_public_path__ + "39e2bee9eb2823b1b9016f39aecb556f.pdf";